<script setup lang="ts">
  defineProps<{
    code: string,
  }>()
</script>

<template>
  <span class="px-2 rounded text-xs bg-gray-100 py-1 inline-block whitespace-nowrap">
    {{ code }}
  </span>
</template>
